// src/apis/pageAPI.js

import { api } from "./configs/axiosConfigs";
import { defineCancelApiObject } from "./configs/axiosUtils";

export const CartAPI = {
  GetCart: async function (cancel = false) {
    try {
      const response = await api.request({
        url: `/ShoppingCart/GetCart`,
        method: "GET",
        // retrieving the signal value by using the property name
        signal: cancel
          ? cancelApiObject[this.GetCart.name].handleRequestCancellation()
              .signal
          : undefined,
      });

      return response;
    } catch (error) {}
  },

  addProduct: async function (data, cancel = false) {
    const response = await api.request({
      url: `/ShoppingCart/AddProduct`,
      method: "POST",
      data: data,
      signal: cancel
        ? cancelApiObject[this.addProduct.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    return response;
  },

  updateProductQuantity: async function (data, cancel = false) {
    const response = await api.request({
      url: `/ShoppingCart/UpdateProductQuantity`,
      method: "PUT",
      data: data,
      signal: cancel
        ? cancelApiObject[
            this.updateProductQuantity.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    return response;
  },

  removeProduct: async function (data, cancel = false) {
    const response = await api.request({
      url: `/ShoppingCart/RemoveProduct`,
      method: "DELETE",
      data: data,
      signal: cancel
        ? cancelApiObject[this.removeProduct.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    return response;
  },

  confirmCart: async function (data, cancel = false) {
    const response = await api.request({
      url: `/ShoppingCart/ConfirmCart`,
      method: "POST",
      data: data,
      signal: cancel
        ? cancelApiObject[this.confirmCart.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    return response;
  },

  getOrderById: async function (orderCode, cancel = false) {
    try {
      const response = await api.request({
        url: `/ShoppingCart/GetOrderById/${orderCode}`,
        method: "GET",
        // retrieving the signal value by using the property name
        signal: cancel
          ? cancelApiObject[this.getOrderById.name].handleRequestCancellation()
              .signal
          : undefined,
      });

      return response;
    } catch (error) {}
  },
};

const cancelApiObject = defineCancelApiObject(CartAPI);
